import React, { useState, useEffect } from 'react'
import { Box, Textarea, Flex, Group, Button } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrder } from '../../../../../services/orders'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'

const defaultVal = {
  excerpt: '',
}

const FormAdjustOrderExcerpt = ({ onCloseForm }) => {
  const { summary } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [loadingForm, setLoadingForm] = useState(false)

  const submitUpdateOrderExcerpt = async (form) => {
    setLoadingForm(true)
    try {
      const response = await updateOrder(orderId, form)
      if (response.success) {
        onCloseForm()
        dispatch(getOrderDetail(orderId))
        notificationSuccess('Update Order Successfully', 'This data has been updated')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (summary) {
      handleSetForm(summary)
    }
  }, [summary])

  const handleSetForm = (value) => {
    const dataDetail = {
      excerpt: value.excerpt,
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  return (
    <Box>
      <Box mb='md'>
        <Textarea
          name='excerpt'
          label="Order Excerpt"
          placeholder="Input order excerpt"
          value={formData.excerpt}
          onChange={(val) => handleChangeForm('excerpt', val.target.value)}
          size='xs'
          autosize
          minRows={4}
          maxRows={4}
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitUpdateOrderExcerpt(formData)}>{summary ? 'Update' : 'Create'}</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustOrderExcerpt